
import Swiper from "swiper";
/* 
Swiper属性记录：

// 设置slider容器能够同时显示的slides数量
slidesPerView: 5,
// 是否循环播放，默认为false，可设置为true
loop: true,
// 是否启用自由模式功能，默认为false，可设置为true
freeMode: true, 
// 在 loop 模式下使用，该参数设置所要用到的loop 个数
loopedSlides: 5, 
// 会在每个可见slide增加一个类名（swiper-slide-visible）
watchSlidesVisibility: true, 
// 配合 watchSlidesVisibility 使用的
watchSlidesProgress: true, 






*/



/**
* 
* @desc 轮播图
* 
*/
const swiperFn = {
   /**
   * 
   * @desc 公共轮播（无任何默认效果）
   * @example common('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   common: (domName, param) => {
      if (!domName) return
      if (!param) return
      return new Swiper(domName, param)
   },
   /**
   * 
   * @desc 无缝轮播（默认自动播放）
   * @example seamless('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   seamless: (domName, param) => {
      if (!domName) return
      param = Object.assign({
         loop: true,
         // 在slide之间设置距离（单位px）
         spaceBetween: 15,
         slidesPerView: 'auto',
         slidesPerGroup: 1,
         // 是否启用自由模式功能，默认为false，可设置为true
         freeMode: true,
         // 速度
         speed: 5000,
         // 用户操作swiper之后，是否禁止autoplay
         autoplayDisableOnInteraction: false,
         //如果需要自动切换海报
         autoplay: {
            //时间 毫秒
            delay: 0,
            //用户操作之后是否停止自动轮播默认true
            disableOnInteraction: false,
         },
      }, param);
      return new Swiper(domName, param)
   },
   /**
   * 
   * @desc 异形轮播(默认自动播放)
   * @example alien('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   alien: (domName, param) => {
      if (!domName) return
      param = Object.assign({
         slidesPerView: 1.4,
         centeredSlides: true,
         loop: true,
         pagination: {
            el: '.swiper-pagination2',
            clickable: true,
          },
         autoplay: {
            delay: 3000,
            disableOnInteraction: false,
         },
      }, param);
      return new Swiper(domName, param)
   },
   /**
   * 
   * @desc 缩略图轮播(默认自动播放),注意缩略图类名默认为：thumbnail-thumbs
   * @example thumbnail.main('.swiper',{thumbs: {this.$swiper.thumbnail.thumb('.thumbnail-thumbs')}})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   thumbnail: {
      /* 子轮播 */
      thumb: (domName, param) => {
         if (!domName) return
         param = Object.assign({
            // 设置slider容器能够同时显示的slides数量
            slidesPerView: 5,
            // 是否循环播放，默认为false，可设置为true
            loop: true,
            // 是否启用自由模式功能，默认为false，可设置为true
            freeMode: true,
            // 在 loop 模式下使用，该参数设置所要用到的loop 个数
            loopedSlides: 5,
            // 会在每个可见slide增加一个类名（swiper-slide-visible）
            watchSlidesVisibility: true,
            // 配合 watchSlidesVisibility 使用的
            watchSlidesProgress: true,
         }, param);
         return new Swiper(domName, param)
      },
      /* 主轮播 */
      main: (domName, param) => {
         if (!domName) {
            return
         }
         param = Object.assign({
            pagination: {
               // 控制和绑定 分页器导航
               el: '.swiper-pagination', // 绑定指示器的类名
               clickable: true, // 点击分页器的指示点分页器会控制Swiper切换，true控制，false不控制
            },
            // 设置slider容器能够同时显示的slides数量
            slidesPerView: 'auto',
            // 是否循环播放，默认为false，可设置为true。
            loop: true,
            // 在 loop 模式下使用，该参数设置所要用到的loop 个数
            loopedSlides: 5,
            // 是否自动播放，默认为false，可设置为true。
            autoplay: {
               // 自动切换的时间间隔
               delay: 4000,
               // 用户操作swiper之后，是否禁止autoplay。默认为true：停止
               disableOnInteraction: false,
            },
            // thumbs组件用于制作带缩略图的swiper
            thumbs: {
               swiper: swiperFn.thumbnail.thumb('.thumbnail-thumbs')
            },
         }, param);
         return new Swiper(domName, param)
      },
   },
   /**
   * 
   * @desc 卡片化轮播(默认自动播放)
   * @example cardBased('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   cardBased: (domName, param) => {
      if (!domName) return
      param = Object.assign({
         // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
         direction: 'horizontal',
         // 设置为true 则开启loop模式  衔接滑动
         loop: true,
         // 自动滑动
         autoplay: {
            delay: 3000,
            // 如果设置为true，当切换到最后一个slide时停止自动切换。
            stopOnLastSlide: false,
            // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
            disableOnInteraction: false,
         },
         // 切换效果 "coverflow"（3d流）
         effect: 'coverflow',
         // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
         slidesPerView: 'auto',
         // 设定为true时，active slide会居中，而不是默认状态下的居左。
         centeredSlides: true,
         // 在slide之间设置距离（单位px）。
         spaceBetween: -150,
         // 设置为true则点击slide会过渡到这个slide。
         slideToClickedSlide: true,
         // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
         // loopAdditionaSlider: 0,
         coverflowEffect: {
            // slide做3d旋转时Y轴的旋转角度
            rotate: 0,
            // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
            stretch: 0,
            // slide的位置深度。值越大z轴距离越远，看起来越小。
            depth: 70,
            // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
            modifier: 10,
            // 是否开启slide阴影
            slideShadows: true,
         },
      }, param);
      return new Swiper(domName, param)
   },
   /**
   * 
   * @desc 无缝滚动纵向(默认自动播放)
   * @example longitudinal('.swiper',{loop: false,})
   * @param domName dom元素
   * @param param 配置数据
   * 
   */
   longitudinal: (domName, param) => {
      if (!domName) return
      param = Object.assign({
         loop: true,
         slidesPerView: 'auto',
         direction: 'vertical',
         speed: 5000,
         // 用户操作swiper之后，是否禁止autoplay
         autoplayDisableOnInteraction: false,
         // // 如果需要自动切换海报
         autoplay: {
            //时间 毫秒
            delay: 0,
            //用户操作之后是否停止自动轮播默认true
            disableOnInteraction: false,
         },
      }, param);
      return new Swiper(domName, param)
   },


}
export default {
   ...swiperFn
}